import React from 'react';
import { Box, useColorMode } from '@chakra-ui/react';
import logo_light from '../../img/vivai-light-logo.svg';
import logo_dark from '../../img/vivai-dark-logo.svg';
import logo_v_light from '../../img/v-light-logo.svg';
import logo_v_dark from '../../img/v-dark-logo.svg';

const LogoComponent = ( {isCollapsed, ...props} ) => {
    const { colorMode } = useColorMode();
    return (
        <Box
            as="img"
            src={!isCollapsed ? colorMode === 'dark' ? logo_dark : logo_light : colorMode === 'dark' ? logo_v_dark : logo_v_light}
            alt="Viva AI Logo"
            {...props}
        />
    );
};

export default LogoComponent;
